var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-multi-hero", attrs: { id: _vm.id } }, [
    _c(
      "div",
      {
        staticClass: "c-multi-hero__nav",
        attrs: { "aria-controls": _vm.id + "-content" }
      },
      _vm._l(_vm.teasers, function(teaser, index) {
        return index < 3
          ? _c(
              "button",
              {
                key: index,
                staticClass: "c-multi-hero__nav-item",
                attrs: {
                  type: "button",
                  id: _vm.id + "-button" + index,
                  "aria-pressed": _vm.selected === index ? "true" : "false"
                },
                on: {
                  click: function($event) {
                    return _vm.setSelected(index)
                  }
                }
              },
              [
                _c("span", { staticClass: "c-multi-hero__nav-item-text" }, [
                  _c(
                    "span",
                    { staticClass: "c-multi-hero__nav-item-heading" },
                    [
                      _vm._v(
                        _vm._s(
                          teaser.navHeading ? teaser.navHeading : teaser.heading
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "c-multi-hero__nav-item-tagline" },
                    [
                      _vm._v(
                        _vm._s(
                          teaser.navTagLine ? teaser.navTagLine : teaser.tagline
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm._m(0, true)
              ]
            )
          : _vm._e()
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "c-multi-hero__content",
        style: "background-image: url('" + _vm.currentTeaser.image + "')",
        attrs: {
          id: _vm.id + "-content",
          "aria-live": "polite",
          "aria-atomic": "true",
          "aria-labelledby": _vm.id + "-button" + _vm.selected
        }
      },
      [
        _c("div", { staticClass: "c-multi-hero__content-text" }, [
          _c("p", { staticClass: "c-multi-hero__content-heading" }, [
            _vm._v(
              "\r\n                " +
                _vm._s(_vm.currentTeaser.heading) +
                "\r\n            "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "c-multi-hero__content-tagline" }, [
            _vm._v(
              "\r\n                " +
                _vm._s(_vm.currentTeaser.tagline) +
                "\r\n            "
            )
          ]),
          _vm._v(" "),
          _vm.currentTeaser.link && _vm.currentTeaser.linkText
            ? _c(
                "a",
                {
                  staticClass: "c-button c-button--icon c-button--highlight",
                  attrs: { href: _vm.currentTeaser.link }
                },
                [
                  _c("span", { staticClass: "c-button--right" }, [
                    _vm._v(_vm._s(_vm.currentTeaser.linkText))
                  ]),
                  _vm._v(" "),
                  _c("v-icon", { attrs: { name: "icon-arrow-circle" } })
                ],
                1
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "c-multi-hero__nav-item-icon" }, [
      _c("span")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }